// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"842f35b4","189":"44501cc8","297":"5fa3461b","301":"b124831c","327":"aaedbaa2","345":"61f6ab78","369":"064b1a7c","618":"0ec0e6ed","648":"75994385","652":"aa8bada5","721":"deb9ba1f","932":"46ced056"}[chunkId] + ".chunk.js";
};